import { Tab } from "@headlessui/react";
import React, { useEffect, useMemo, useRef, useState } from "react";
import TabsMobile from "../__template/TabsMobileComponent";
import new1 from "../../assets/images/icon_mutation/new1.svg";
import new2 from "../../assets/images/icon_mutation/new2.svg";
import old1 from "../../assets/images/icon_mutation/old1.svg";
import old2 from "../../assets/images/icon_mutation/old2.svg";
import { formatCurrency } from "../../config/global";
import { useDispatch } from "react-redux";
import { useAppDispatch, useAppSelector } from "../../core/feature/hooks";
import { setLoading } from "../../core/feature/config/configSlice";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import "react-spring-bottom-sheet/dist/style.css";
import User from "../../core/models/user";
import { getMutation, getMutationOlder } from "../../core/service/api_mutation";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Select from "react-select";
import {
  getOlderTransactions,
  getTransactions,
} from "../../core/service/api_transaction";
import { useTranslation } from "react-i18next";
import { result } from "lodash";
import CustomApp from "../../core/models/customApp";
import { isDarkColor } from "../../config/DarkColorChecker";
const ComponentTransactionHistory = () => {
  const user: User = useAppSelector((state) => state.user.user);
  const [transaction, setTransaction] = useState<any>([]);
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const [transactionOlder, setTransactionOlder] = useState<any>([]);
  const [monthOption, setMonthOption] = useState<any>([]);
  const [monthOlderOption, setMonthOlderOption] = useState<any>([]);
  const [yearOption, setYearOption] = useState<any>([]);
  const [yearOlderOption, setYearOlderOption] = useState<any>([]);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [activeTab, setActiveTab] = useState(0);
  const [balanceIn, setBalanceIn] = useState(0);
  const [balanceOut, setBalanceOut] = useState(0);

  const [balanceInOlder, setBalanceInOlder] = useState(0);
  const [balanceOutOlder, setBalanceOutOlder] = useState(0);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  let month = "";
  month = String(Number(moment().format("MM")));
  month = month.length == 2 ? month : "0" + month;

  const [selectedMonth, setSelectedMonth] = useState(
    month.length == 2 ? month : "0" + month
  );
  const [selectedOlderMonth, setSelectedOlderMonth] = useState(
    month.length == 2 ? month : "0" + month
  );
  const year = new Date().getFullYear().toString();
  const [selectedYear, setSelectedYear] = useState(year);
  const [selectedOlderYear, setSelectedOlderYear] = useState(year);
  const { t } = useTranslation();

  // this.month = String(Number(moment().format("MM")) - 1)
  const is3Month = true;
  let btnMonth: any;
  let btnYear: any;
  let currentDate: any;
  let minDate2: any;
  let maxDate2: any;
  let monthYear: any;

  currentDate = moment().subtract(89, "days").format("YYYY-MM-DD");
  minDate2 = "2020-01-01";
  maxDate2 = moment().subtract(90, "days").format("MM");

  var a = `${t("TRANSACTION.new")}`;
  var b = `${t("TRANSACTION.older")}`;

  var january = t("OTHER.month.january");
  var february = t("OTHER.month.february");
  var march = t("OTHER.month.march");
  var april = t("OTHER.month.april");
  var may = t("OTHER.month.may");
  var june = t("OTHER.month.june");
  var july = t("OTHER.month.july");
  var august = t("OTHER.month.august");
  var september = t("OTHER.month.september");
  var october = t("OTHER.month.october");
  var november = t("OTHER.month.november");
  var december = t("OTHER.month.december");
  let [categories] = useState({
    [a]: [],
    [b]: [],
  });
  var yearArray: any = [];
  var monthArray = [
    { value: "01", label: january },
    { value: "02", label: february },
    { value: "03", label: march },
    { value: "04", label: april },
    { value: "05", label: may },
    { value: "06", label: june },
    { value: "07", label: july },
    { value: "08", label: august },
    { value: "09", label: september },
    { value: "10", label: october },
    { value: "11", label: november },
    { value: "12", label: december },
  ];

  function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(" ");
  }

  const getTransaction = async (month: string, year: string) => {
    dispatch(setLoading(true));
    getTransactions(month, year)
      .then((res: any) => {
        dispatch(setLoading(false));
        let tempIn = 0;
        let tempOut = 0;
        res.data.content.forEach((s: any) => {
          if (s.amount.toString().substring(0, 1) == "-") {
            tempIn -= s.amount;
          } else {
            tempOut += s.amount;
          }
        });
        setBalanceIn(tempIn);
        setBalanceOut(tempOut);
        setTransaction(res.data.content);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  // const addMoreMutations = async () => {
  //   setPage(page + 1);

  //   dispatch(setLoading(true));
  //   getMutation(fromDate, today, page + 1, size)
  //     .then((res) => {
  //       dispatch(setLoading(false));
  //       setMutations(mutations.concat(res.data.content));
  //       console.log(res.data);
  //     })
  //     .catch((err) => {
  //       dispatch(setLoading(false));
  //       navigate("/login", { replace: true });
  //     });
  // };

  const getTransactionOlder = async (month: string, year: string) => {
    console.log("masuk");

    dispatch(setLoading(true));
    getOlderTransactions(month, year)
      .then((res: any) => {
        dispatch(setLoading(false));
        let tempIn = 0;
        let tempOut = 0;
        res.data.content.forEach((s: any) => {
          if (s.amount.toString().substring(0, 1) == "-") {
            tempIn -= s.amount;
          } else {
            tempOut += s.amount;
          }
        });
        setBalanceInOlder(tempIn);
        setBalanceOutOlder(tempOut);
        setTransactionOlder(res.data.content);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  // const addMoreMutationsOlder = async () => {
  //   setPage(page + 1);

  //   dispatch(setLoading(true));
  //   getMutationOlder(fromDateOlder, toDateOlder, page + 1, size)
  //     .then((res) => {
  //       dispatch(setLoading(false));
  //       setMutationsOlder(mutationsOlder.concat(res.data.content));
  //       console.log(res.data);
  //     })
  //     .catch((err) => {
  //       dispatch(setLoading(false));
  //       navigate("/login", { replace: true });
  //     });
  // };

  // const currentSizeMutations = useMemo(() => {
  //   const a = mutations.length;
  //   const b = a / (page + 1);
  //   console.log("b", a, b);

  //   return b;
  // }, [mutations]);

  // const currentSizeMutationsOlder = useMemo(() => {
  //   const a = mutationsOlder.length;
  //   const b = a / (page + 1);
  //   console.log("b", a, b);

  //   return b;
  // }, [mutationsOlder]);

  const goToDetail = async (
    transactionName: String,
    month: String,
    year: String,
    isOlder: boolean
  ) => {
    navigate(`/transaction-detail`, {
      state: {
        month: month,
        year: year,
        transactionName: transactionName,
        isOlder: isOlder,
      },
    });
  };

  const handleChangeMonth = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    console.log(value);

    setSelectedMonth(value);
  };
  const handleChangeYear = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    console.log(value);

    setSelectedYear(value);
  };

  const handleChangeOlderMonth = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const value = event.target.value;
    console.log(value);

    setSelectedOlderMonth(value);
  };
  const handleChangeOlderYear = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const value = event.target.value;
    console.log(value);

    setSelectedOlderYear(value);
  };
  const setIs3Month = async () => {
    currentDate = moment().format("MM");
    let result = [];
    for (let i = currentDate - 1; i > currentDate - 5; i--) {
      result.push(monthArray[(monthArray.length + i) % monthArray.length]);
    }
    setMonthOption(result);
    var tempYear = parseInt(year);
    for (var i = 0; i < 2; i++) {
      var tempYear = parseInt(year) - i;
      yearArray.push({ value: `${tempYear}`, label: `${tempYear}` });
    }
    setYearOption(yearArray);
  };

  const setOlder3Month = async () => {
    setMonthOlderOption(monthArray);

    setSelectedOlderMonth(monthArray[maxDate2 - 1].value);
    console.log(maxDate2);

    for (var i = 0; i < 3; i++) {
      var tempYear = parseInt(year) - i;
      yearArray.push({ value: `${tempYear}`, label: `${tempYear}` });
    }
    setYearOlderOption(yearArray);
    setSelectedOlderYear(yearArray[0].value);
  };
  useEffect(() => {
    if (activeTab == 0) {
      setIs3Month();

      getTransaction(
        selectedMonth.length == 2 ? selectedMonth : "0" + selectedMonth,
        selectedYear
      );
    } else {
      setOlder3Month();
    }
  }, [selectedMonth, selectedYear, activeTab]);

  useEffect(() => {
    console.log(selectedOlderYear);
    if (activeTab == 1) {
      getTransactionOlder(
        selectedOlderMonth.length == 2
          ? selectedOlderMonth
          : "0" + selectedOlderMonth,
        selectedOlderYear
      );
    }
  }, [selectedOlderMonth, selectedOlderYear, activeTab]);

  return (
    <div className="min-h-screen h-full  bg-psp-primary">
      <div className="bg-white px-8 pt-8 pb-3  sticky top-0 z-50">
        <TabsMobile
          name={`${t("TRANSACTION.title")}`}
          backUrl={"home"}
        ></TabsMobile>
      </div>
      <Tab.Group
        onChange={(index) => {
          console.log("Changed selected tab to:", index);
          setActiveTab(index);
        }}
      >
        <Tab.List className="flex space-x-1  bg-white p-1  sticky top-24 z-50">
          {Object.keys(categories).map((category, key) => (
            <Tab
              key={category}
              style={{
                backgroundColor:
                  activeTab == key ? customApp.app_accent_color : "#B9B9B9",
                color: activeTab == key ? customApp.app_accent_color : "#fff",
              }}
              className={({ selected }) =>
                classNames(
                  "w-full py-2 mx-4 text-sm font-medium  mb-3",
                  " ",
                  selected
                    ? `font-montserrat rounded-xl text-sm font-semibold ${isDarkColor(customApp.app_accent_color)?"text-white":"text-black"}`
                    : "text-psp-gray bg-psp-primary rounded-xl font-montserrat text-sm font-semibold"
                )
              }
            >
              {category}
            </Tab>
          ))}
        </Tab.List>

        <Tab.Panels>
          <Tab.Panel className="top-to-bottom">
            <div className="flex flex-col bg-white px-4 pb-3">
              <h1 className="font-semibold text-sm ">
                {t("TRANSACTION.info")}
              </h1>
              <div className="flex flex-row gap-2 w-full">
                <select
                  className="grow text-psp-gray bg-psp-primary font-medium rounded-lg h-10 w-fit"
                  value={selectedMonth}
                  onChange={handleChangeMonth}
                >
                  {monthOption.map((option: any) => (
                    <option value={option.value}>{option.label}</option>
                  ))}
                </select>
                <select
                  className="grow text-psp-gray bg-psp-primary font-medium rounded-lg h-10 w-fit"
                  value={selectedYear}
                  onChange={handleChangeYear}
                >
                  {yearOption.map((option: any) => (
                    <option value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="flex flex-col bg-white  px-4 mb-3 sticky top-[152px] z-50">
              <div className="flex flex-row justify-between">
                <h1 className="font-light text-xs">
                  {t("TRANSACTION.balanceIn")}
                </h1>
                <h1 className="font-light text-xs text-green-500">
                  {formatCurrency(balanceIn)}
                </h1>
              </div>
              <div className="flex flex-row justify-between">
                <h1 className="font-light text-xs">
                  {t("TRANSACTION.balanceOut")}
                </h1>
                <h1 className="font-light text-xs text-rose-500">
                  {formatCurrency(balanceOut * -1)}
                </h1>
              </div>
            </div>
            {transaction.length < 1 ? (
              <div className="flex justify-center">
                <span className="font-normal text-xs text-center">
                  {t("OTHER.dataNotFound")}
                </span>
              </div>
            ) : (
              <div className="flex flex-col gap-2.5 px-4">
                {transaction.map((res: any) => (
                  <div className="bg-white rounded-xl shadow-md font-montserrat">
                    <div className="flex flex-row px-3 py-3 gap-2 items-center">
                      <div className="flex flex-col grow gap-1">
                        <h1 className="m-0 font-semibold text-xs font-montserrat">
                          {res.transactionName}
                        </h1>
                        <div className="flex flex-col divide-y gap-2 mt-2">
                          <div className="grid grid-cols-2">
                            <span className="font-montserrat font-light text-xs">
                              {t("TRANSACTION.amount")}
                            </span>
                            <span className="font-montserrat font-light text-xs text-right">
                              : {formatCurrency(res.amount * -1)}
                            </span>
                          </div>
                          <div className="flex flex-row pt-2">
                            <span className="font-montserrat grow font-light text-xs">
                              {t("TRANSACTION.numOfTransaction")}
                            </span>
                            <span className="font-montserrat  flex-0 font-light text-xs">
                              {res.count}
                            </span>
                          </div>
                        </div>
                        <div className="flex mt-2">
                          <button
                            onClick={() =>
                              goToDetail(
                                res.transactionName,
                                selectedMonth,
                                selectedYear,
                                false
                              )
                            }
                            style={{
                              backgroundColor: customApp?.app_accent_color,
                            }}
                            className={`px-3 py-1 ml-auto rounded-lg text-sm font-medium ${isDarkColor(customApp.app_accent_color)?'text-white':'text-black'}`}
                          >
                            {t("TRANSACTION.detail")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* {currentSizeMutations < 10 ? (
              ""
            ) : (
              <div className="flex w-full mt-2">
                <button
                  onClick={addMoreMutations}
                  className="w-full transparent px-2 py-2.5 rounded-lg text-psp-hover underline text-center items-center font-bold text-xs active:text-psp-active "
                >
                                    {t("OTHER.showMore")}

                </button>
              </div>
            )} */}
          </Tab.Panel>
          <Tab.Panel className="top-to-bottom">
            <div className="flex flex-col bg-white px-4 pb-3">
              <h1 className="font-semibold text-sm ">
                {t("TRANSACTION.info")}
              </h1>
              <div className="flex flex-row gap-2 w-full">
                <select
                  className="grow text-psp-gray bg-psp-primary font-medium rounded-lg h-10 w-fit"
                  value={selectedOlderMonth}
                  onChange={handleChangeOlderMonth}
                >
                  {monthOlderOption.map((option: any) => (
                    <option value={option.value}>{option.label}</option>
                  ))}
                </select>
                <select
                  className="grow text-psp-gray bg-psp-primary font-medium rounded-lg h-10 w-fit"
                  value={selectedOlderYear}
                  onChange={handleChangeOlderYear}
                >
                  {yearOlderOption.map((option: any) => (
                    <option value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="flex flex-col bg-white  px-4 mb-3 sticky top-[152px] z-50">
              <div className="flex flex-row justify-between">
                <h1 className="font-light text-xs">
                  {t("TRANSACTION.balanceIn")}
                </h1>
                <h1 className="font-light text-xs text-green-500">
                  {formatCurrency(balanceInOlder)}
                </h1>
              </div>
              <div className="flex flex-row justify-between">
                <h1 className="font-light text-xs">
                  {t("TRANSACTION.balanceOut")}
                </h1>
                <h1 className="font-light text-xs text-rose-500">
                  {formatCurrency(balanceOutOlder * -1)}
                </h1>
              </div>
            </div>
            {transactionOlder.length < 1 ? (
              <div className="flex justify-center">
                <span className="font-normal text-xs text-center">
                  {t("OTHER.dataNotFound")}
                </span>
              </div>
            ) : (
              <div className="flex flex-col gap-2.5 px-4">
                {transactionOlder.map((res: any) => (
                  <div className="bg-white rounded-xl shadow-md font-montserrat">
                    <div className="flex flex-row px-3 py-3 gap-2 items-center">
                      <div className="flex flex-col grow gap-1">
                        <h1 className="m-0 font-semibold text-xs font-montserrat">
                          {res.transactionName}
                        </h1>
                        <div className="flex flex-col divide-y gap-2 mt-2">
                          <div className="grid grid-cols-2">
                            <span className="font-montserrat font-light text-xs">
                              {t("TRANSACTION.amount")}
                            </span>
                            <span className="font-montserrat font-light text-xs text-right">
                              : {formatCurrency(res.amount * -1)}
                            </span>
                          </div>
                          <div className="flex flex-row pt-2">
                            <span className="font-montserrat grow font-light text-xs">
                              {t("TRANSACTION.numOfTransaction")}
                            </span>
                            <span className="font-montserrat  flex-0 font-light text-xs">
                              {res.count}
                            </span>
                          </div>
                        </div>
                        <div
                          onClick={() =>
                            goToDetail(
                              res.transactionName,
                              selectedOlderMonth,
                              selectedOlderYear,
                              true
                            )
                          }
                          className="flex mt-2"
                        >
                          <button
                            style={{
                              backgroundColor: customApp?.app_accent_color,
                            }}
                            className={`px-3 py-1 ml-auto rounded-lg text-sm font-medium ${isDarkColor(customApp.app_accent_color)?'text-white':'text-black'}`}
                          >
                            Detail
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* {currentSizeMutationsOlder < 10 ? (
              ""
            ) : (
              <div className="flex w-full mt-2">
                <button
                  onClick={addMoreMutationsOlder}
                  className="w-full transparent px-2 py-2.5 rounded-lg text-psp-hover underline text-center items-center font-bold text-xs active:text-psp-active "
                >
                                    {t("OTHER.showMore")}

                </button>
              </div>
            )} */}
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default ComponentTransactionHistory;
